import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMode } from '../../context/ModeContext'; // 1. Import your ModeContext
import { 
  NavContainer, 
  NavName, 
  RightSection, 
  SwitchButton, 
  NavArrow 
} from './Navbar.styles';

const Navbar = () => {
  const location = useLocation();
  const isArtMode = location.pathname === '/art';
  const [isScrolled, setIsScrolled] = useState(false);

  // 2. Consume the global terminal state
  const { isTerminalExpanded } = useMode();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <NavContainer 
      $isArtMode={isArtMode} 
      $isScrolled={isScrolled}
      // 3. Add the animation logic
      initial={{ y: 0, opacity: 1 }}
      animate={{ 
        y: isTerminalExpanded ? -100 : 0, 
        opacity: isTerminalExpanded ? 0 : 1 
      }}
      transition={{ 
        type: 'spring', 
        stiffness: 300, 
        damping: 30 
      }}
    >
      
      <NavName to="/">
        darin
      </NavName>

      <RightSection>
        {isArtMode ? (
          <SwitchButton to="/" $direction="left">
            <NavArrow $direction="left">←</NavArrow>
            dev
          </SwitchButton>
        ) : (
          <SwitchButton to="/art" $direction="right">
            art
            <NavArrow $direction="right">→</NavArrow>
          </SwitchButton>
        )}
      </RightSection>

    </NavContainer>
  );
};

export default Navbar;